import React, { useState, useEffect, useRef } from "react";
import { Outlet } from "react-router";
import Sidebar from "../components/sidebar";
import { LogoIcon } from "../assets/svgs";
import { appName } from "../utils/constants";
import { LuMenu } from "react-icons/lu";

function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const sidebarRef = useRef<HTMLDivElement | null>(null);
  const menuButtonRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        menuButtonRef.current &&
        !menuButtonRef.current.contains(event.target)
      ) {
        setSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="h-screen overflow-hidden">
      <div className="flex h-screen bg-white">
        <Sidebar
          isOpen={sidebarOpen}
          toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
          sidebarRef={sidebarRef}
        />
        <div className="flex-1 flex flex-col overflow-hidden bg-bg">
          <div className="md:hidden flex items-center gap-x-2 bg-bgCard px-2 py-3 mb-1 ">
            <div
              className="text-2xl cursor-pointer"
              ref={menuButtonRef}
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              <LuMenu />
            </div>
            <div className="">
              <LogoIcon width="30px" height="30px" />
            </div>
            <div className="text-base font-semibold">{appName}</div>
          </div>
          <main className="flex-1 overflow-x-hidden overflow-y-auto px-2 py-4">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}

export default MainLayout;
